let bannerCache = null;

function BannerService(restangular) {
    this._api = restangular;
}

/**
 * @description - Get list of banners
 * @function
 * @params object {location, PageNumber [default = 1], PageSize [default = 10], stockcode}
 * @name getBanners
 * @return {Object} - return banners object
 */
BannerService.prototype.getBanners = function ({ location, pageNumber = 1, pageSize = 10, stockcode }) {

    if (bannerCache) {
        return bannerCache;
    }

    bannerCache = this._api.one('Banners').get({
        Location: location,
        PageNumber: pageNumber,
        PageSize: pageSize,
        Stockcode: stockcode
    });

    return bannerCache;
};

BannerService.prototype.clearBanners = function () {
    bannerCache = null;
};

module.exports = BannerService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/banners/banner-service.js
 **/